<template>
    <my-login />
</template>

<script>
export default {
    components: {
        'my-login': () => import('@/components/login')
    }

}
</script>

<style>

</style>
